import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { formatError } from "@/lib/api";
import BrandLogo from "@/components/BrandLogo";
import { ArrowLeft } from "lucide-react";

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const { login } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("लॉगिन सफल");
      nav("/admin", { replace: true });
    } catch (err) {
      toast.error(formatError(err));
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-[#F1F5F9] font-admin flex flex-col">
      <div className="p-6">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-slate-600 hover:text-[#0F172A]" data-testid="back-home">
          <ArrowLeft className="w-4 h-4"/> होम पेज
        </Link>
      </div>
      <div className="flex-1 flex items-center justify-center px-4">
        <div className="w-full max-w-md bg-white border border-slate-200 rounded-lg shadow-sm p-8">
          <div className="flex items-center gap-3 mb-6">
            <BrandLogo size={48}/>
            <div>
              <div className="text-lg font-bold text-[#0F172A]">व्यवस्थापक लॉगिन</div>
              <div className="text-xs text-slate-500">INDIAN-NEWS-21 — Admin Panel</div>
            </div>
          </div>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label htmlFor="email" className="text-slate-700">ईमेल</Label>
              <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email" />
            </div>
            <div>
              <Label htmlFor="pw" className="text-slate-700">पासवर्ड</Label>
              <Input id="pw" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password" />
            </div>
            <Button type="submit" className="w-full bg-[#0F172A] hover:bg-[#1E3A8A]" disabled={busy} data-testid="login-submit">
              {busy ? "प्रवेश हो रहा है…" : "लॉगिन करें"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
